const footer = {
  'copyright': '© Neuronalys® 2021 - Tous droits réservés',
  'copyright-app': '{{app}}® est une marque déposée',
  'legal': 'Mentions légales',
}

export default footer
